module.exports = __webpack_public_path__ + "img/title-bg1.e67e67db.png";